import {getReservationList, signReOrder} from "@/api";
import {message} from "../../utils/common";
import {ElMessageBox} from "element-plus";
import baseConfig from "@/api/config";

export default {
    data() {
        return {
            currentPage: 1,
            pageNums: 20,
            totalCount: 0,
            queryParams: {
                cardPatientName: '',
                cardIdentity: '',
                reStatusMiniDoc: '',
                cardPatientPhone: ''
            },
            tableLoading: false,
            tableData: [],
            dateTime: '',
            tableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,
            doctorInfo: null,
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
        }
    },
    mounted() {
        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
        setTimeout(() => {
            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 80;
        },1000)
    },
    created() {
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.patientInfo.docId = this.doctorInfo.doctorId;
        }
        this.getReservationListInfo();
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams.cardPatientName = "";
            this.queryParams.reStatusMiniDoc = "";
            this.queryParams.cardIdentity = "";
            this.queryParams.cardPatientPhone = "";
            this.getReservationListInfo();
        },

        // 选择预约状态
        chooseStatus() {
            this.currentPage = 1;
            this.getReservationListInfo();
        },

        // 切换分页
        handleCurrentChange: function(val) {
            this.currentPage = val;
            this.getReservationListInfo();
        },

        // 切换分页
        handleSizeChange: function(val) {
            this.pageNums = val;
            this.getReservationListInfo();
        },


        // 查询预约列表
        getReservationListInfo: function () {
            this.tableData = [];
            this.tableLoading = true;
            const data = {
                pageNum: this.currentPage,
                pageSize: this.pageNums,
                doctorId: this.doctorInfo ? this.doctorInfo.doctorId : null,
                cardIdentity: this.queryParams.cardIdentity,
                cardPatientName: this.queryParams.cardPatientName,
                reStatusMiniDoc: this.queryParams.reStatusMiniDoc,
                cardPatientPhone: this.queryParams.cardPatientPhone,
            };
            getReservationList(data).then(res => {
                const rdata = res.data;
                this.tableLoading = false;
                if (rdata.code === 200) {
                    this.tableData = rdata.rows;
                    this.totalCount = rdata.total;

                    this.tableData.forEach((item) => {
                        let birYear = new Date(item.cardPatientBirth).getFullYear();
                        let nowYear = new Date().getFullYear();
                        item.age = parseInt(nowYear - birYear);
                        item.reTimeTypeText = item.reTimeType === 'am'?'上午': item.reTimeType === 'pm'?'下午':'晚上';
                        item.reStatusText = item.reStatus === '1'?'待支付':item.reStatus === '2'?
                            '已完成':item.reStatus === '3'?'已失效':item.reStatus === '4'?'已取消':item.reStatus === '5'?'待就诊':item.reStatus === '6'?'就诊中':item.reStatus === '7'?'已过号':item.reStatus === '8'?'待签到':'未知';
                        if (item.cardPatientSex === '0') {
                            item.sexText = '男';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                        } else if (item.cardPatientSex === '1'){
                            item.sexText = '女';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                        } else {
                            item.sexText = '未知';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                        }
                    })
                }
            }).catch(error => {
                message(error, "error");
            });
        },


        // 签到
        handleSign(row) {
            const reId = row.reId;
            ElMessageBox.confirm('确定要签到？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info',
            }).then(() => {
                signReOrder(reId).then(res => {
                    if (res.code === 200) {
                        message("签到成功", "success");
                        this.getReservationListInfo();
                    } else {
                        message(res.msg || "签到失败", "warning");
                        this.getReservationListInfo();
                    }
                }).catch(error => {
                    message(error, "error");
                });
            }).catch(() => {});
        },

        // 接诊
        openMedical(row) {
            console.log(row);
            this.patientInfo.name = row.cardPatientName;
            this.patientInfo.sex = row.cardPatientSex;
            this.patientInfo.age = row.age;
            this.patientInfo.phoneNumber = row.cardPatientPhone;
            this.patientInfo.identity = row.cardIdentity;
            window.sessionStorage.removeItem("reservationPatient");
            window.sessionStorage.setItem("reservationPatient", JSON.stringify(this.patientInfo));

            this.$router.push({path: '/admin/clinictreat'});
            this.$store.state.adminleftnavnum = 'clinictreat'; //设置左侧导航2-2 active
        },


    }
}
